var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAntennaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 89,
    viewBox: "0 0 125 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.026 64.5106L102.269 26.4985C101.93 25.9905 101.422 25.6519 100.83 25.6519H84.7443C83.813 25.6519 83.0511 26.4138 83.0511 27.345C83.0511 28.2763 83.813 29.0382 84.7443 29.0382H99.8137L119.878 64.0873H4.31764L20.5723 29.0382H36.2343C37.1656 29.0382 37.9275 28.2763 37.9275 27.345C37.9275 26.4138 37.1656 25.6519 36.2343 25.6519H19.5564C18.8791 25.6519 18.2865 26.0752 18.0325 26.6678L0.338639 64.68C0.169319 64.9339 0 65.2726 0 65.6959V86.6068C0 87.538 0.761937 88.3 1.69319 88.3H122.841C123.772 88.3 124.534 87.538 124.534 86.6068V65.6959C124.534 65.1879 124.365 64.7646 124.026 64.5106ZM3.38639 84.8289V67.4737H121.148V84.8289H3.38639Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0395 38.5201C61.3782 38.8588 61.8015 39.0281 62.2248 39.0281C62.6481 39.0281 63.0714 38.8588 63.41 38.5201L78.9027 23.0274C79.58 22.3501 79.58 21.3342 78.9027 20.6569C78.2254 19.9797 77.2095 19.9797 76.5323 20.6569L63.918 33.1866V1.69319C63.918 0.761937 63.156 0 62.2248 0C61.2935 0 60.5316 0.761937 60.5316 1.69319V33.1866L48.002 20.6569C47.3247 19.9797 46.3088 19.9797 45.6315 20.6569C44.9542 21.3342 44.9542 22.3501 45.6315 23.0274L61.0395 38.5201Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntennaIcon);
export default __webpack_public_path__ + "static/media/antenna-icon.d63bbdc924d5ab2804937020a7cfbfa6.svg";
export { ForwardRef as ReactComponent };